/// <reference path="wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Utilities;
    (function (Utilities) {
        const LOG_CATEGORY = "WPT.OBHelper.Actions";
        class ActionHelper {
            constructor(core) {
                this._log = null;
                this._isReady = false;
                this._executionQueue = [];
                this._queueInProcess = false;
                this._currentAction = null;
                this._currentDocument = null;
                this._currentCallback = null;
                this._executeCurrentCallback = false;
                this._nextStepProcessQueue = true;
                // Comment modal support
                this._currentCommentModalSession = null;
                this._commentModalInput = null;
                this._commentModalOK = null;
                this._currentComment = "";
                // Verify PW modal support
                this._currentVerifyModalSession = null;
                this._verifyModalInput = null;
                this._verifyModalOK = null;
                this._logon = null;
                this.executeAction = (action, doc, executeCallback = null) => {
                    this._log.info("ActionHelper.executeAction()");
                    this._executionQueue.push({ action: action, document: doc, callback: executeCallback });
                    if (!this._isReady) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("not ready yet, wait for queue execution...");
                        }
                    }
                    else if (this._queueInProcess) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("queue already in process, wait for execution...");
                        }
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("starting queue processing...");
                        }
                        this._processQueue();
                    }
                };
                this._checkNextStep = () => {
                    this._log.info("ActionHelper._checkNextStep()");
                    if (this._nextStepProcessQueue) {
                        this._processQueue();
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("do nothing this time...");
                        }
                        this._nextStepProcessQueue = true;
                    }
                };
                this._executeCurrentAction = () => {
                    this._log.info("ActionHelper._executeCurrentAction()");
                    this._currentComment = null;
                    this._currentCommentModalSession = null;
                    this._currentVerifyModalSession = null;
                    this._executeCurrentCallback = false;
                    if (this._currentAction.hasOwnProperty('ConfirmMessage') && this._currentAction.ConfirmMessage) {
                        this._showContinueCancelModal();
                    }
                    else {
                        this._checkCommentRequired();
                    }
                };
                this._showContinueCancelModal = () => {
                    this._core.Helper.presentWarningContinueModal(this._currentAction.ConfirmMessage, this._checkCommentRequired, 'STR_WPT_WARNING', this._userCancelled);
                };
                this._userCancelled = () => {
                    this._clearState();
                    this._processQueue();
                };
                this._checkCommentRequired = () => {
                    if (this._currentAction.RequiresComment) {
                        this._showCommentModal();
                    }
                    else {
                        this._checkVerifyPasswordRequired();
                    }
                };
                this._clearState = () => {
                    this._log.info("ActionHelper._clearState()");
                    this._currentAction = null;
                    this._currentCallback = null;
                    this._executeCurrentCallback = false;
                    this._currentComment = null;
                    this._currentCommentModalSession = null;
                    this._currentVerifyModalSession = null;
                    this._currentDocument = null;
                };
                this._setReady = () => {
                    this._log.info("ActionHelper._setReady()");
                    this._isReady = true;
                    this._currentCallback = null;
                    this._executeCurrentCallback = false;
                    this._processQueue();
                };
                this._processQueue = () => {
                    this._log.info("ActionHelper._processQueue()");
                    this._queueInProcess = true;
                    if (this._logon == null) {
                        this._logon = this._core.Navigation.Logon;
                    }
                    if (this._executeCurrentCallback && this._currentCallback)
                        this._currentCallback(this._currentComment);
                    let entry = this._executionQueue.shift();
                    if (entry) {
                        this._currentAction = entry.action;
                        this._currentDocument = entry.document;
                        this._currentCallback = entry.callback;
                        this._executeCurrentAction();
                    }
                    else {
                        this._log.info("no more queue entries");
                        this._clearState();
                        this._queueInProcess = false;
                    }
                };
                this._storeCommentHtml = (htmlData) => {
                    this._log.info("ActionHelper._storeCommentHtml()");
                    ActionHelper.CommentHtmlData = htmlData;
                    if (ActionHelper.VerifyHtmlData != null) {
                        this._setReady();
                    }
                };
                this._storeVerifyPwHtml = (htmlData) => {
                    this._log.info("ActionHelper._storeVerifyPwHtml()");
                    ActionHelper.VerifyHtmlData = htmlData;
                    if (ActionHelper.CommentHtmlData != null) {
                        this._setReady();
                    }
                };
                this._showCommentModal = () => {
                    this._log.info("ActionHelper._showCommentModal()");
                    let modalSession = 'comment-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentCommentModalSession = modalSession;
                        modal.DIV.innerHTML = ActionHelper.CommentHtmlData;
                        this._commentModalInput = modal.DIV.querySelector('#actionCommentTextarea');
                        this._commentModalOK = modal.DIV.querySelector('#actionCommentOkButton');
                        let message = this._currentAction.CommentMessage ? this._currentAction.CommentMessage : "STR_WPT_COMMENTWARNING";
                        this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'title', "STR_WPT_CLOSE");
                        this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'aria-label', "STR_WPT_CLOSE");
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#actionCommentHeading'), "STR_WPT_COMMENT");
                        this._core.Helper.setElementTranslationAttribute(this._commentModalInput, 'placeholder', "STR_WPT_COMMENT");
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#actionCommentLabel'), message);
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#actionCommentCancelButtonLabel'), "STR_WPT_CANCEL");
                        this._core.Helper.setElementTranslation(this._commentModalOK.querySelector('#actionCommentOkButtonLabel'), "STR_WPT_LABEL_OK");
                        this._commentModalOK.addEventListener('click', this._commentOKClicked);
                        this._commentModalInput.addEventListener('keyup', this._enableDisableCommentOK);
                        let ah = this;
                        modal.JQ.one('shown.bs.modal', function () {
                            ah._commentModalInput.focus();
                        });
                        // first show modal (default event listener for 'hidden.bs.modal' need to be added first)
                        this._core.showModal(modalSession);
                        modal.JQ.one('hidden.bs.modal', function () {
                            ah._checkNextStep();
                        });
                    }
                    else {
                        console.error("unable to show action comment modal, modal placeholder is already used");
                        this._currentCallback = null;
                        this._processQueue();
                    }
                };
                this._enableDisableCommentOK = (event) => {
                    this._log.info("ActionHelper._enableDisableCommentOK()");
                    if (this._commentModalInput.value != "")
                        this._commentModalOK.disabled = false;
                    else
                        this._commentModalOK.disabled = true;
                };
                this._commentOKClicked = (event) => {
                    this._log.info("ActionHelper._commentOKClicked()");
                    if (this._commentModalInput.value == "") {
                        this._core.hideModal(this._currentCommentModalSession);
                        this._clearState();
                        return;
                    }
                    else {
                        this._currentComment = this._commentModalInput.value;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`Action Comment Dialog got: ${this._currentComment}`);
                        }
                        let modal = this._core.getModal(this._currentCommentModalSession);
                        let ah = this;
                        modal.JQ.one('hidden.bs.modal', function () {
                            ah._checkVerifyPasswordRequired();
                        });
                        this._nextStepProcessQueue = false;
                        this._core.hideModal(this._currentCommentModalSession);
                        this._currentCommentModalSession = null;
                    }
                };
                this._checkVerifyPasswordRequired = () => {
                    this._log.info("ActionHelper._checkVerifyPasswordRequired()");
                    // Check if we need to do anything
                    let needsPassword = false;
                    if (!this._currentAction.RequiresPasswordVerification) {
                        this._log.trace('RequiresPasswordVerification = false');
                    }
                    else {
                        if (this._currentAction.PasswordVerificationKeywordType) {
                            // If we get here we have a specific keyword to check
                            let keyContent = this._core.OBHelper.GetKeywordValue(this._currentDocument, this._currentAction.PasswordVerificationKeywordType);
                            if (keyContent != null) {
                                if (['Y', 'YES', 'TRUE', 'VERIFY'].indexOf(keyContent.toUpperCase()) > -1)
                                    needsPassword = true;
                            }
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`key => ${needsPassword}`);
                            }
                        }
                        else {
                            this._log.trace('VerifyPassword = true');
                            needsPassword = true;
                        }
                    }
                    // We have a flag
                    if (needsPassword)
                        this._showVerifyPasswordModal();
                    else {
                        this._executeCurrentCallback = true;
                        this._processQueue();
                    }
                };
                this._showVerifyPasswordModal = () => {
                    this._log.info("ActionHelper._showVerifyPasswordModal()");
                    if (!this._logon.SupportPasswordValidation) {
                        this._core.Helper.presentWarningModal("STR_WPT_PASSWORD_VERIFICATION_REQUIRED");
                        this._clearState();
                        this._processQueue();
                        return;
                    }
                    // set up modal
                    let modalSession = 'verify-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentVerifyModalSession = modalSession;
                        modal.DIV.innerHTML = ActionHelper.VerifyHtmlData;
                        this._verifyModalInput = modal.DIV.querySelector('#actionVerifyPwInput');
                        this._verifyModalOK = modal.DIV.querySelector('#actionVerifyPwOkButton');
                        let message = this._currentAction.PasswordVerificationMessage ? this._currentAction.PasswordVerificationMessage : "STR_WPT_PASSWORD";
                        this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'title', "STR_WPT_CLOSE");
                        this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'aria-label', "STR_WPT_CLOSE");
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#actionVerifyPwHeading'), "STR_WPT_ENTERPASSWORD");
                        this._core.Helper.setElementTranslationAttribute(this._verifyModalInput, 'placeholder', "STR_WPT_PASSWORD");
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#actionVerifyPwLabel'), message);
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#actionVerifyPwCancelButtonLabel'), "STR_WPT_CANCEL");
                        this._core.Helper.setElementTranslation(this._verifyModalOK.querySelector('#actionVerifyPwOkButtonLabel'), "STR_WPT_LABEL_OK");
                        this._verifyModalOK.addEventListener('click', this._verifyOKClicked);
                        this._verifyModalInput.addEventListener('keyup', this._enableDisableVerifyOK);
                        this._verifyModalInput.addEventListener('keyup', this._verifyCaptureEnter);
                        let ah = this;
                        modal.JQ.one('shown.bs.modal', function () {
                            ah._verifyModalInput.focus();
                        });
                        // first show modal (default event listener for 'hidden.bs.modal' need to be added first)
                        this._core.showModal(modalSession);
                        modal.JQ.one('hidden.bs.modal', function () {
                            ah._checkNextStep();
                        });
                    }
                    else {
                        console.error("unable to show action verify password modal, modal placeholder is already used");
                        this._currentCallback = null;
                        this._processQueue();
                    }
                };
                this._verifyCaptureEnter = (event) => {
                    this._log.info("ActionHelper._verifyCaptureEnter()");
                    if (event.key === "Enter") {
                        if (this._verifyModalInput.value != "")
                            this._verifyOKClicked(null);
                    }
                };
                this._enableDisableVerifyOK = (event) => {
                    this._log.info("ActionHelper._enableDisableVerifyOK()");
                    if (this._verifyModalInput.value != "")
                        this._verifyModalOK.disabled = false;
                    else
                        this._verifyModalOK.disabled = true;
                };
                this._verifyOKClicked = (event) => {
                    this._log.info("ActionHelper._verifyOKClicked()");
                    let hashInput = `${this._verifyModalInput.value}%${this._core.getCurrentConnectionId()}`;
                    let hashOutput = window.hex_sha512(hashInput);
                    if (this._logon.checkValidationHash(hashOutput)) {
                        this._executeCurrentCallback = true;
                        this._core.hideModal(this._currentVerifyModalSession);
                        this._currentVerifyModalSession = null;
                    }
                    else {
                        this._core.Helper.presentWarningModal("STR_WPT_PASSWORD_NOT_VERIFIED");
                    }
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ActionHelper::constructor");
                let ready = true;
                if (ActionHelper.CommentHtmlData == null) {
                    ready = false;
                    core.Loader.getVersionedHTML('assets/wpt/html/actionCommentModal.html', this._storeCommentHtml, this._core.Helper.missingHtmlErrorCallback);
                }
                if (ActionHelper.VerifyHtmlData == null) {
                    ready = false;
                    core.Loader.getVersionedHTML('assets/wpt/html/actionVerifyPwModal.html', this._storeVerifyPwHtml, this._core.Helper.missingHtmlErrorCallback);
                }
                this._isReady = ready;
            }
        }
        ActionHelper.CommentHtmlData = null;
        ActionHelper.VerifyHtmlData = null;
        Utilities.ActionHelper = ActionHelper;
    })(Utilities = WPTNamespace.Utilities || (WPTNamespace.Utilities = {}));
})(WPTNamespace || (WPTNamespace = {}));
